import { EnumTiposEtiqueta } from "../mxenumerados";

/**
 * Retorna o tipo de etiqueta (Formatado/NaoFormatado)
 * @param {string} etiqueta
 * @returns {EnumTiposEtiqueta}
 */
export function verificaTipoEtiqueta(etiqueta) {
    if (etiqueta.charAt(0) === "$") return EnumTiposEtiqueta.NaoFormatado;
    else if (parseInt(etiqueta)) return EnumTiposEtiqueta.Formatado;
    else {
        console.log(etiqueta.length);
        const error = new Error("Etiqueta inválida: " + etiqueta);
        error.name = "etiqueta_invalida";
        throw error;
    }
}
